// ── 직원 등록·수정 창 칸: 칸 안 왼쪽에 항목 이름 (2026-11-05 맵찔찔이님 — 입사·퇴사일자 칸과 같은 모양) ──────
//   <label> 로 감싸 항목 이름과 칸을 잇는다(이름은 눌러도 칸이 눌린다, dateLabelStyle 의 pointerEvents none).
import React from 'react';
import { ChevronDown } from 'lucide-react';
import { inputStyle } from './styles';
import { dateLabelStyle } from './userModalStyles';
import { stdSearchChevron } from '../adminlayout/designStandard';

// 글자 시작 위치 — 입사일자 칸과 같은 76. 이름이 긴 칸만 pad 를 넘긴다.
// 높이 43 고정(공용 검색 칸 stdSearchSelect 와 같은 값) — 날짜 칸만 높이가 달라(PC 43·휴대폰 42, 글자 칸 41·46) 옆 칸과 어긋났다.
export const labeledInputStyle = (pad = 76) => ({
  ...inputStyle, width: '100%', boxSizing: 'border-box', height: 43, paddingTop: 0, paddingBottom: 0, paddingLeft: pad,
});

// 사파리는 select 를 자기 방식으로 그려 왼쪽 여백을 무시한다(항목 이름과 값이 겹침) → 기본 모양을 끄고 ▾ 를 직접 얹는다(designStandard stdSearchSelect 와 같은 방법).
export const labeledSelectStyle = {
  ...labeledInputStyle(),
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  appearance: 'none',
  backgroundImage: 'none',
  paddingRight: 34,
  cursor: 'pointer',
  textOverflow: 'ellipsis',
};

// select = ▾ 표시, top = 여러 줄 칸(메모)이라 이름을 위쪽에
export default function LabeledField({ label, select = false, top = false, style, children }) {
  return (
    <label style={{ display: 'block', position: 'relative', ...style }}>
      <span style={top ? { ...dateLabelStyle, top: 10, transform: 'none' } : dateLabelStyle}>{label}</span>
      {children}
      {select && <ChevronDown size={15} style={stdSearchChevron} />}
    </label>
  );
}
